import { HttpException } from "http-repository-cache";
import ClientRepository from "core/client/repositories/ClientRepository";
import { CreateClientResponse } from "core/client/entities/Client";
import { ApiCreateClientRequest } from "@/core/client/entities/ApiCreateClientRequest";
import { UpdateProfessionRemunerationResponse } from "core/client/entities/ProfessionRemuneration";
import { createClientUrl } from "../../api/clientBackendEndpoints/clientBackendEndpoints";
import handleRequestError from "../../http/services/handleRequestError/handleRequestError";
import { ApiResponse } from "../../api/types/ApiResponse";
import { executeRequest } from "../../http/services/executeRequest/executeRequest";
import { UpdateContactAddressResponse } from "@/core/client/entities/ContactAddress";
import { UpdateMatrimonialRegimeResponse } from "@/core/client/entities/MatrimonialRegime";
import {
  RepositoryResult,
  RepositoryResultFactory,
} from "core/shared/types/RepositoryResult";
import { UpdatePatrimoineResponse } from "@/core/client/entities/Patrimoine";
import { HttpClient } from "../../http/HttpClient";

export default class ClientRepositoryBackend implements ClientRepository {
  constructor(private readonly httpClient: HttpClient) {}

  createClient(
    clientData: ApiCreateClientRequest,
  ): Promise<RepositoryResult<CreateClientResponse>> {
    return executeRequest(
      () =>
        this.httpClient.post<
          ApiResponse<CreateClientResponse>,
          ApiCreateClientRequest
        >({
          url: createClientUrl(),
          body: clientData,
          withAuth: true,
        }),
      // The API returns { code, message, data } where data contains our response
      (data) => ({
        message: data.message || "Client created successfully",
        success: data.success || true,
        client: data.client,
      }),
    );
  }

  async updateProfessionRemuneration(
    clientId: string,
  ): Promise<RepositoryResult<UpdateProfessionRemunerationResponse>> {
    try {
      // TODO: Implement actual API call when endpoint is available
      // For now, return a mock successful response
      const response: UpdateProfessionRemunerationResponse = {
        message: `Profession remuneration updated successfully for client ${clientId}`,
        success: true,
        clientId: clientId,
      };

      return RepositoryResultFactory.success(response);
    } catch (error) {
      return RepositoryResultFactory.error(
        handleRequestError(error as HttpException<unknown, unknown>),
      );
    }
  }

  async updateContactAddress(
    clientId: string,
  ): Promise<RepositoryResult<UpdateContactAddressResponse>> {
    try {
      // TODO: Implement actual API call when endpoint is available
      const response: UpdateContactAddressResponse = {
        message: `Contact address updated successfully for client ${clientId}`,
        success: true,
        clientId: clientId,
      };

      return RepositoryResultFactory.success(response);
    } catch (error) {
      return RepositoryResultFactory.error(
        handleRequestError(error as HttpException<unknown, unknown>),
      );
    }
  }

  async updateMatrimonialRegime(
    clientId: string,
  ): Promise<RepositoryResult<UpdateMatrimonialRegimeResponse>> {
    try {
      // TODO: Implement actual API call when endpoint is available
      const response: UpdateMatrimonialRegimeResponse = {
        message: `Matrimonial regime updated successfully for client ${clientId}`,
        success: true,
        clientId: clientId,
      };

      return RepositoryResultFactory.success(response);
    } catch (error) {
      return RepositoryResultFactory.error(
        handleRequestError(error as HttpException<unknown, unknown>),
      );
    }
  }

  async updatePatrimoine(
    clientId: string,
  ): Promise<RepositoryResult<UpdatePatrimoineResponse>> {
    try {
      // TODO: Implement actual API call when endpoint is available
      const response: UpdatePatrimoineResponse = {
        message: `Patrimoine updated successfully for client ${clientId}`,
        success: true,
        clientId: clientId,
      };

      return RepositoryResultFactory.success(response);
    } catch (error) {
      return RepositoryResultFactory.error(
        handleRequestError(error as HttpException<unknown, unknown>),
      );
    }
  }
}
